export default __webpack_public_path__ + "static/media/ian-pic.cea3b38c.png";